<div
  class="flex h-full w-full overflow-x-auto"
  #overflowRef
  [ngStyle]="{ 'padding-right': scrollIndicatorWidth + 'px', marginRight: -scrollIndicatorWidth + 'px' }"
>
  <lib-schedule-calendar-time-column
    class="pt-[24px]"
    [ngStyle]="{ height: containerHeight() + 'px' }"
    [calendarGridTemplateRows]="timeGridTemplateRows"
    [hours]="hours"
    [minutesInTimeline]="minutesInTimeline"
  >
  </lib-schedule-calendar-time-column>
  <lib-schedule-calendar-my-day
    [ngStyle]="{ height: containerHeight() + 'px' }"
    [style.gridTemplateRows]="calendarGridTemplateRows"
    [myDay]="myDay"
    [selectedAppointmentId]="selectedAppointmentId"
    [isShowcase]="isShowcase"
    (calendarItemClick)="onCalendarItemClick($event)"
  ></lib-schedule-calendar-my-day>
  <div
    #scheduleGridRef
    class="z-100 relative grid auto-cols-min grid-flow-col gap-x-1 gap-y-px"
    [ngStyle]="{ height: containerHeight() + 'px' }"
    [style.gridTemplateColumns]="isScheduleLoadingSignal() ? loadingGridTemplateColumns : calendarGridTemplateColumns()"
    [style.gridTemplateRows]="calendarGridTemplateRows"
  >
    <lib-schedule-calendar-header
      [style.gridTemplateColumns]="calendarGridTemplateColumns()"
      [isScheduleLoadingSignal]="isScheduleLoadingSignal"
      [columnLoadingSkeletons]="columnLoadingSkeletons"
      [operatories]="operatories"
    ></lib-schedule-calendar-header>

    <!-- BODY LOADING LAYER -->
    @if (isScheduleLoadingSignal() && !isSafari()) {
      <div [class]="bodySubGridTemplate">
        <div class="col-start-1 col-end-[-1] row-start-1 row-end-[-1] grid grid-cols-subgrid grid-rows-subgrid gap-x-1">
          @for (item of columnLoadingSkeletons; track $index) {
            @for (item of rowLoadingSkeletons; track $index) {
              <div
                class="animate-pulse rounded-xl bg-background-light-grey"
                [style.gridRowStart]="{ hour: $index, minute: 0 } | scheduleTimeToGridRow"
                [style.gridRowEnd]="{ hour: $index + 1, minute: 0 } | scheduleTimeToGridRow"
              ></div>
            }
          }
        </div>
      </div>
    }

    <!-- BODY BASE LAYER-->
    @if (!isScheduleLoadingSignal()) {
      <div [class]="bodySubGridTemplate">
        <lib-rows-separators-and-time-indicator
          #rowsSeparatorsAndTimeIndicator
          [hours]="hours"
          [intervalCount]="intervalCount"
          [showcaseScrollStartHour]="showcaseScrollStartHour"
          [defaultStartHour]="defaultStartHour"
          [currentTimeWithTimeZone]="currentTimeWithTimeZone"
          [isToday]="isToday"
          [timePassedOfHourInPercent$]="timePassedOfHourInPercent$"
          [isShowcase]="isShowcase"
          [containerRef]="scheduleOverflowRef"
        ></lib-rows-separators-and-time-indicator>

        <!-- empty time slots -->
        @for (el of operatories; track el.id; let index = $index) {
          <div
            class="relative z-10 row-start-1 row-end-[-1] grid grid-rows-subgrid"
            [style.grid-column-start]="columnTemplateCount(index, myDay)"
          >
            @for (hour of hours; track hour) {
              @for (minute of minutesInTimeline; track minute; let first = $first) {
                <div
                  class="row-span-2 rounded-md text-right text-h8 text-text-extra-light"
                  [class.pt-1]="first"
                  (click)="onTimeSlotClick({ hour, minute, operatory: { id: el.id, name: el.operatoryName } })"
                ></div>
              }
            }
          </div>
        }
      </div>
    }

    <!--BODY EVENTS LAYER-->
    @if (!isScheduleLoadingSignal()) {
      <div [class]="bodySubGridTemplate" class="pointer-events-none">
        @for (el of operatories; track el.id; let index = $index) {
          <div class="z-[90] row-start-1 row-end-[-1] grid grid-rows-subgrid" [style.grid-column-start]="columnTemplateCount(index, myDay)">
            <!-- exceptions -->
            @for (exception of el.exceptions; track exception) {
              <div
                class="pointer-events-auto col-end-[-1] rounded-lg bg-background-disabled p-2 text-h7 @container-size"
                [style.gridRowStart]="exception.from | scheduleTimeToGridRow"
                [style.gridRowEnd]="exception.to | scheduleTimeToGridRow"
              >
                <span class="hidden @h-[16px]:inline"
                  >{{ exception.from.hour | hourToDayPartHour
                  }}{{ exception.from.minute === 0 ? '' : '.' + (exception.from.minute | padStart: 2 : '0') }}
                  {{ exception.from.hour | hourToDayPart }}</span
                >
                <span class="hidden @h-[16px]:inline">&nbsp;-&nbsp;</span>
                <span class="hidden @h-[16px]:inline"
                  >{{ exception.to.hour | hourToDayPartHour
                  }}{{ exception.to.minute === 0 ? '' : '.' + (exception.to.minute | padStart: 2 : '0') }}
                  {{ exception.to.hour | hourToDayPart }}
                </span>
              </div>
            }

            <!-- events -->
            @for (event of el.events; track event.id) {
              <div
                class="pointer-events-auto z-10 flex cursor-pointer items-center rounded-lg bg-background-disabled p-[6px] text-text-primary @container-size @w-[100px]:p-2"
                [ngClass]="{
                  'shadow-card outline outline-1 outline-text-light': event.id === selectedEventId,
                  '!cursor-auto': isEditAppointment()
                }"
                [style.gridRowStart]="event.from | scheduleTimeToGridRow"
                [style.gridRowEnd]="event.to | scheduleTimeToGridRow"
                (click)="onEventClick(event.id)"
              >
                <div class="relative hidden h-full flex-col gap-1 overflow-hidden @h-[24px]:flex">
                  <div class="typo-h8-semibold line-clamp-1 @w-[100px]:typo-h7-semibold">{{ event.title }}</div>

                  @if (!isCompactViewSignal()) {
                    <div class="flex items-center text-h8 @w-[100px]:text-h7">
                      <div class="w-full overflow-hidden truncate whitespace-nowrap">
                        <span class="shrink-0"
                          >{{ event.from.hour | hourToDayPartHour
                          }}{{ event.from.minute === 0 ? '' : '.' + (event.from.minute | padStart: 2 : '0') }}
                          {{ event.from.hour | hourToDayPart }}</span
                        >
                        <span class="hidden shrink-0 @h-[40px]:inline">&nbsp;-&nbsp;</span>
                        <span class="hidden shrink-0 @h-[40px]:inline"
                          >{{ event.to.hour | hourToDayPartHour
                          }}{{ event.to.minute === 0 ? '' : '.' + (event.to.minute | padStart: 2 : '0') }}
                          {{ event.to.hour | hourToDayPart }}
                        </span>
                      </div>
                    </div>
                  }
                </div>

                <div class="@h-[24px]:hidden">
                  <div class="typo-h8-semibold line-clamp-1 @w-[100px]:typo-h7-semibold">{{ event.title }}</div>
                </div>
              </div>
            }

            <!-- appointments -->
            @for (appointment of el.appointments; track appointment.id) {
              @if (!appointment.isEdited && (!appointment.isTentative || showTentativeSignal())) {
                <lib-schedule-calendar-item
                  class="pointer-events-auto relative cursor-pointer"
                  [style.outlineColor]="appointment.color"
                  [ngClass]="{
                    'shadow-card': appointment.id === selectedAppointmentId,
                    'outline outline-1': appointment.isTentative || appointment.id === selectedAppointmentId,
                    '!cursor-auto': isEditAppointment()
                  }"
                  (click)="onCalendarItemClick(appointment.id)"
                  (dblclick)="onCalendarItemDoubleClick()"
                  [style.gridRowStart]="appointment.from | scheduleTimeToGridRow"
                  [style.gridRowEnd]="appointment.to | scheduleTimeToGridRow"
                  [vm]="appointment"
                  [statusOptions]="statusOptions()"
                  [isShowcase]="isShowcase"
                  [areTreatmentsLoaded]="areTreatmentsLoadedSignal"
                  [ffdPushTagOnClick]="{
                    event: TagEvent.ScheduleAppointmentDetailsOpened
                  }"
                  [isCompactViewSignal]="isCompactViewSignal"
                  (openHealthHistory)="onOpenHealthHistory($event)"
                  (setComplete)="onCompleteAppointment($event)"
                  (editAppointment)="onScheduleEditClick($event)"
                  (deleteAppointment)="onDeleteClick($event)"
                  (changeStatus)="onChangeStatus($event)"
                  (rightClick)="onCalendarItemClick($event.id)"
                />
              }
            }

            <!-- new appointment -->
            @if (el.newAppointment) {
              <lib-schedule-calendar-item
                class="pointer-events-auto relative cursor-pointer shadow-card outline outline-1"
                [style.outlineColor]="el.newAppointment.color"
                [style.gridRowStart]="el.newAppointment.from | scheduleTimeToGridRow"
                [style.gridRowEnd]="el.newAppointment.to | scheduleTimeToGridRow"
                [vm]="el.newAppointment"
                [statusOptions]="statusOptions()"
                [isNewAppointmentItem]="true"
                [isShowcase]="isShowcase"
              />
            }
          </div>
        }
      </div>
    }
  </div>
</div>
@if (!isScrollAtEnd()) {
  <div
    #scrollGradientRef
    class="absolute right-10 z-[100] w-[32px] bg-gradient-to-r from-transparent to-text-white"
    [ngStyle]="{ height: containerHeight() + 'px' }"
  ></div>
}
